import { ChonkyButton } from '@/components/shared/chonky-button'
import { cn } from '@/lib/utils'
import type { LucideIcon } from 'lucide-react'

interface EmptyStateProps {
  /** Ícone a ser exibido */
  icon: LucideIcon
  /** Título do estado vazio */
  title: string
  /** Descrição explicativa */
  description: string
  /** Texto do botão de ação (opcional) */
  actionLabel?: string
  /** Callback do botão de ação */
  onAction?: () => void
  /** Classes CSS adicionais */
  className?: string
}

/**
 * Componente de estado vazio reutilizável
 *
 * Usado para exibir feedback visual quando não há dados para mostrar.
 * Inclui ícone, título, descrição e CTA opcional.
 */
export function EmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn('flex flex-col items-center justify-center py-12 px-4 text-center', className)}
    >
      <div className="rounded-full bg-muted p-4 mb-4">
        <Icon className="h-8 w-8 text-muted-foreground" />
      </div>
      <h3 className="text-lg font-medium">{title}</h3>
      <p className="text-sm text-muted-foreground mt-1 mb-4">{description}</p>
      {actionLabel && onAction && (
        <ChonkyButton variant="secondary" onClick={onAction}>
          {actionLabel}
        </ChonkyButton>
      )}
    </div>
  )
}
